import React from "react";
import NumberSpinner from "../NumberSpinner/NumberSpinner";

export default class GuestSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: this.props.visible ? this.props.visible : false,
    };

    this.onTogglePopover = this.onTogglePopover.bind(this);
  }

  componentDidMount() {
    $(window).on("click.guest_types_dropdown", (e) => {
      if (this.state.visible && $(e.target).parents(".dropdown").length == 0) {
        this.setState({ visible: false });
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    var $dropdown = $("#dropdown-menu");
    var $window = $(window);

    if (this.state.visible) {
      if ($window.width() < 858) {
        $dropdown.css("left", "auto");
      }
    }
  }

  componentWillUnmount() {
    $(window).off("click.guest_types_dropdown");
  }

  /**
   * Render functions
   */

  render() {
    var total_guest_count = this.getTotalGuestCount();
    return (
      <div className="dropdown GuestSelect" id="guest-select">
        <button
          className="btn-secondary dropdown-toggle "
          type="button"
          onClick={this.onTogglePopover}
        >
          <span>
            <span className="ss-user"></span>{" "}
            <span className="option">
              {total_guest_count}{" "}
              {total_guest_count == 1
                ? I18n.t("guest").toLowerCase()
                : I18n.t("guests").toLowerCase()}
            </span>{" "}
          </span>
          <span className="caret"></span>
        </button>
        {this.state.visible ? (
          <div
            className="dropdown-menu"
            ref="dropdown-menu"
            id="dropdown-menu"
            style={{ display: "block", width: "100%", minWidth: "300px" }}
          >
            {this.renderPopover()}
          </div>
        ) : null}
      </div>
    );
  }

  renderAgeRange(guest_type) {
    if (
      guest_type.maximum_age == null ||
      typeof guest_type.maximum_age == "undefined"
    ) {
      return <span>{guest_type.minimum_age}+</span>;
    } else {
      return (
        <span>
          {guest_type.minimum_age} &ndash; {guest_type.maximum_age}
        </span>
      );
    }
  }

  renderPopover() {
    var guest_types = this.props.guest_types
      .sort((a, b) => a.position - b.position)
      .map((guest_type) => {
        return (
          <div className="row guest-type-form" key={guest_type.id}>
            <div className="col-sm-6">
              <div className="name">
                {guest_type.name} ({this.renderAgeRange(guest_type)})
              </div>
            </div>
            <div className="col-sm-6">
              <NumberSpinner
                id={guest_type.id}
                name={guest_type.id}
                value={this.getGuestCount(guest_type.id)}
                onChange={this.props.onChange}
              />
            </div>
          </div>
        );
      });

    // var dropdownStyle = this.props.source === 'bb' ? {  width: 'auto' } : { width: '130%' };
    var dropdownStyle = { width: "auto" };
    return (
      <div className="guest-types-popover">
        <div className="guest-types-content">
          <div className="guest-types-inner">
            {guest_types}
            <div className="done-button-wrapper" style={dropdownStyle}>
              <div
                className="col-md text-left"
                style={{ fontSize: ".75rem", justifyContent: "left" }}
              >
                {I18n.t("additional_charges_may_apply")}
              </div>

              {/* {I18n.t('additional_charges_may_apply')} */}
              <button
                type="button"
                style={{ justifyContent: "right" }}
                className="btn"
                onClick={this.onTogglePopover}
              >
                {I18n.t("done")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  /**
   * Change handlers
   */

  onTogglePopover(e) {
    e.stopPropagation();
    e.preventDefault();

    if (this.props.onSubmit) {
      this.props.onSubmit();
    }
    // this.setState({visible: !this.state.visible})

    if (this.props.onToggleDropdown) {
      let e = {};
      e.target = "guest_select";
      e.value = !this.state.visible;
      this.props.onToggleDropdown(e);
    } else {
      this.setState({ visible: !this.state.visible }, this.closePromoCode());
    }
  }

  /**
   * Helper functions
   */

  closePromoCode = () => {
    $(window).trigger("click.PromoCodeInput");
  };

  getGuestCount(guest_type_id) {
    for (var i = 0, ilen = this.props.guests.length; i < ilen; i++) {
      if (this.props.guests[i].id == guest_type_id) {
        return parseInt(this.props.guests[i].number_of_guests);
      }
    }
    return 0;
  }

  getTotalGuestCount() {
    var count = 0;

    for (var i = 0, ilen = this.props.guests.length; i < ilen; i++) {
      count =
        count +
        (typeof this.props.guests[i].number_of_guests == "number"
          ? this.props.guests[i].number_of_guests
          : parseInt(this.props.guests[i].number_of_guests));
    }

    return count;
  }
}
